<template>
    <div v-if="detail" class="tech-detail-panel" data-testid="technician-detail-panel">
        <button class="tech-detail-panel__close" @click="$emit('close')">
            <i class="mc-fa icon-outline_close"></i>
        </button>
        <TechnicianPopup :detail="detail" :visible-fields="visibleFields" :generate-link="generateLink"
            @close="$emit('close')" @show-clock-in="$emit('show-clock-in', detail)" @open-gmap="$emit('open-gmap')"
            @share="$emit('share', $event)" />
    </div>
</template>

<script>
import TechnicianPopup from './TechnicianPopup.vue'

export default {
    name: 'TechnicianDetailPanel',
    components: { TechnicianPopup },
    props: {
        detail: { type: Object, required: true },
        visibleFields: { type: Array, default: () => [] },
        generateLink: { type: Function, required: true },
    },
}
</script>

<style scoped>
.tech-detail-panel {
    position: absolute;    /* dari fixed -> absolute */
    top: 0;
    right: 0;              /* menempel ke kanan container */
    height: 100%;          /* sekarang setinggi container map */
    background: #ffffff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
}

.tech-detail-panel__close {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    color: #64748b;
    cursor: pointer;
}
</style>
